import { Button } from "@/components/Button/Button";
import { GenericLink } from "@/components/GenericLink/GenericLink";
import { LinkData } from "@/types/graphqlResponse";
import { DataAnalyticsEvents } from "@/utils/DataAnalytics/models/DataAnalyticsDefinitions";
import { useAnalytics } from "@/utils/DataAnalytics/useAnalytics";

interface ButtonChild {
  cta: LinkData;
  variant: "primary" | "secondary";
}

/**
 * @deprecated remove in LEXUS-7093
 */
export const ButtonChild: React.FC<ButtonChild> = ({ cta, variant }) => {
  const { registerEvent } = useAnalytics();

  const handleClick = () => {
    const data = {
      event: "modelMenuButtonClick",
      componentLink: cta.url,
      componentLinkText: cta.label || "None",
    };
    registerEvent(DataAnalyticsEvents.CLICK, data);
  };

  return (
    <GenericLink
      key={cta.url}
      asWrapper
      href={cta.url}
      target={cta.target || undefined}
      onClick={handleClick}
    >
      <Button tabIndex={-1} variant={variant} component="span">
        {cta.label}
      </Button>
    </GenericLink>
  );
};
